var map = {
	"./nizzle/backpic.svg": "f8bf",
	"./nizzle/backwall.svg": "3af7",
	"./nizzle/door_closed.svg": "ff53",
	"./nizzle/door_opened.svg": "533b",
	"./nizzle/maindoor.svg": "bcb2",
	"./nizzle/minidoor.svg": "c71b",
	"./nizzle/preview.png": "35f7",
	"./nizzle/weather/backpic_snow.svg": "8240",
	"./nizzle/weather/clouds_1_day.svg": "44ae",
	"./nizzle/weather/clouds_1_night.svg": "c754",
	"./nizzle/weather/clouds_2_day.svg": "19d7",
	"./nizzle/weather/clouds_2_night.svg": "27fd",
	"./nizzle/weather/clouds_3_day.svg": "68b0",
	"./nizzle/weather/clouds_3_night.svg": "b121",
	"./nizzle/weather/dark.svg": "7701",
	"./nizzle/weather/dark_snow.svg": "ba3c",
	"./nizzle/weather/fog.svg": "7982",
	"./nizzle/weather/moon.svg": "0e83",
	"./nizzle/weather/rain_1.svg": "fcaa",
	"./nizzle/weather/rain_2.svg": "80b2",
	"./nizzle/weather/snow_1.svg": "4cfe",
	"./nizzle/weather/snow_2.svg": "1fcd",
	"./nizzle/weather/sun.svg": "0324"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a12";